import secureLocalStorage from "react-secure-storage";

class LocalStorageService {
    getToken = () => secureLocalStorage.getItem("token");

    getAdminUser = () => secureLocalStorage.getItem("adminUser");

    getOwnerUser = () => secureLocalStorage.getItem("ownerUser");

    getCompanyId = () => {
        const companyId = secureLocalStorage.getItem("companyId");
        if (!companyId) return null;
        const parsed = parseInt(companyId);
        return isNaN(parsed) ? null : parsed;
    };

    getCompanyList = () => JSON.parse(secureLocalStorage.getItem("companyList"));

    getCompanyInfo = () => JSON.parse(secureLocalStorage.getItem("companyInfo"));

    getUserData = () => JSON.parse(secureLocalStorage.getItem("userData"));

    setToken = (token = "") => secureLocalStorage.setItem("token", token);
    setAdminUser = (adminUser = "") => secureLocalStorage.setItem("adminUser", adminUser);
    setOwnerUser = (ownerUser = "") => secureLocalStorage.setItem("ownerUser", ownerUser);
    
    setCompanyId = (id = null) => {
        const companiesList = JSON.parse(secureLocalStorage.getItem("companyList") || []);
        const curCompany = companiesList?.find(elem => elem.id === parseInt(id)) || {};
        secureLocalStorage.setItem("companyId", curCompany?.id);
        secureLocalStorage.setItem("companyInfo", JSON.stringify(curCompany));
    }

    setUserData = (data = {}) => secureLocalStorage.setItem("userData", JSON.stringify(data));

    setCompanyList = (list = []) => secureLocalStorage.setItem("companyList", JSON.stringify(list));

    setCompanyInfo = (data = {}) => secureLocalStorage.setItem("companyInfo", JSON.stringify(data));

    setDLGJobId = (jobId = "") => secureLocalStorage.setItem("DLGJobId", jobId);

    getDLGJobId = () => secureLocalStorage.getItem("DLGJobId");

    setDLGExecutionNames = (names = []) => secureLocalStorage.setItem("DLGExecutionNames", JSON.stringify(names));

    getDLGExecutionNames = () => {
        const raw = secureLocalStorage.getItem("DLGExecutionNames");
        if (!raw) return [];
        try { return JSON.parse(raw); } catch { return []; }
    };

    clearLocalStorage = () => {
        secureLocalStorage.clear();
        // Clear global tab preference on logout
        localStorage.removeItem("homepage_last_active_tab");
    };

    clearAll = () => {
        secureLocalStorage.clear();
        // Clear global tab preference on logout
        localStorage.removeItem("homepage_last_active_tab");
    }
}

export default new LocalStorageService();
